import React, { useEffect } from 'react';
import { Message, Icon } from 'semantic-ui-react';
import './CalibrationToast.css';

interface CalibrationToastProps {
  isVisible: boolean;
  type: 'success' | 'error';
  title: string;
  message: string;
  onClose: () => void;
  duration?: number;
}

const CalibrationToast: React.FC<CalibrationToastProps> = ({
  isVisible,
  type,
  title,
  message,
  onClose,
  duration = 5000
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) {
    return null;
  }

  const messageType = type === 'success' ? 'positive' : 'negative';
  const iconName = type === 'success' ? 'check circle' : 'exclamation triangle';

  return (
    <div className={`calibration-toast ${type}`}>
      <Message
        className="toast-message"
        positive={type === 'success'}
        negative={type === 'error'}
        onDismiss={onClose}
        icon
      >
        <Icon name={iconName} />
        <Message.Content>
          <Message.Header>{title}</Message.Header>
          <p>{message}</p>
        </Message.Content>
      </Message>
    </div>
  );
};

export default CalibrationToast;
